import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory, Link as RouterLink } from 'react-router';
import { ButtonV2 } from '@zola/zola-ui';

import { getEventType } from 'components/manage/website/entities/EventTypes';

import { parseStartTime } from '../../../../util/formDataUtil';
import { trackZoomSetupFlow } from '../../../../util/trackingHelper';

import css from './ZoomEventDetailsModule.module.less';

// TODO: add component tests

const ZoomEventDetailsModule = ({ zoomEvent, onEditDetails, handleResetMeeting }) => {
  const {
    hash,
    virtual_meeting: virtualMeeting = {},
    name: eventName,
    type: eventType,
    timezone,
    start_at: startTime,
  } = zoomEvent;

  const { join_url: zoomLink, password, meeting_id: meetingId } = virtualMeeting;

  let formattedDate;
  let formattedTime;
  if (startTime) {
    const { date, startTime: time, tzAbbr } = parseStartTime(startTime, timezone);
    formattedTime = `${time} ${tzAbbr}`;
    formattedDate = date;
  }

  const onClickFinish = () => {
    const { source } = virtualMeeting;
    handleResetMeeting();
    trackZoomSetupFlow('Flow Step Completed', {
      step_name: 'Set Up Link',
      step_number: 2,
      step_value_type: source === 'MANUAL' ? 'Own Link' : 'Create Link',
      step_value: null,
    });
    browserHistory.push(`/wedding/manage/virtual/edit/${hash}`);
  };

  return (
    <div className={css.eventDetails}>
      <div className={css.detailsHeader}>
        <h2 className={css.subTitle}>Event Details</h2>
        <RouterLink
          to={`/wedding/manage/virtual/create/${hash}`}
          onClick={() => {
            onEditDetails(true);
          }}
          className="zola-ui link small"
        >
          Edit Event Details
        </RouterLink>
      </div>
      <div className={css.meetingDetail}>
        <b>Event Name: </b>
        {eventName}
      </div>
      <div className={css.meetingDetail}>
        <b>Event Type: </b>
        {getEventType(eventType)}
      </div>
      <div className={css.meetingDetail}>
        <b>Date: </b>
        {formattedDate}
      </div>
      <div className={css.meetingDetail}>
        <b>Time: </b>
        {formattedTime}
      </div>
      <div className={css.meetingDetail}>
        <b>Zoom Link: </b>
        {zoomLink}
      </div>
      {password && (
        <div className={css.meetingDetail}>
          <b>Meeting Password: </b>
          {password}
        </div>
      )}
      <div className={css.meetingDetail}>
        <b>Meeting ID: </b>
        {meetingId}
      </div>
      {password && (
        <p className={css.passwordNote}>
          Your meeting password is created by Zoom to protect your meeting, and will be visible to
          all guests joining your event. Please do not change your meeting password on the Zoom app.
        </p>
      )}
      <hr />
      <ButtonV2 onClick={onClickFinish}>Next: Edit My Site</ButtonV2>
    </div>
  );
};

ZoomEventDetailsModule.propTypes = {
  zoomEvent: PropTypes.shape({}),
  onEditDetails: PropTypes.func,
};

ZoomEventDetailsModule.defaultProps = {};

export default ZoomEventDetailsModule;



// WEBPACK FOOTER //
// ./src/components/manage/VirtualEvents/ZoomEventDetailsModule/ZoomEventDetailsModule.jsx